/**
 * InkPhD logo — the founder's official artwork.
 *   public/logo.png       [I]nk PhD, black ink + blue "PhD"  (light UI)
 *   public/logo-dark.png  same artwork with the ink turned light (dark UI)
 *
 * Props:
 *   size: 'sm' | 'md' | 'lg' | 'xl'
 *   variant: 'light' | 'dark'  — pick the artwork for the surface behind it
 */
const HEIGHTS = { sm: 18, md: 26, lg: 40, xl: 56 };

export default function InkPhDLogo({ size = 'md', variant = 'light', className = '' }) {
  const h = HEIGHTS[size] || HEIGHTS.md;
  return (
    <img
      src={variant === 'dark' ? '/logo-dark.png' : '/logo.png'}
      alt="InkPhD"
      height={h}
      style={{ height: h, width: 'auto' }}
      className={`select-none ${className}`}
      data-testid="inkphd-logo"
      draggable="false"
    />
  );
}

/** The bracket mark on its own — used for avatars and compact spots. */
export function InkPhDMark({ height = 26, plated = false, className = '' }) {
  return (
    <img
      src={plated ? '/icon-192.png' : '/favicon.png'}
      alt="InkPhD"
      height={height}
      style={{ height, width: height }}
      className={`select-none ${plated ? 'rounded-[22%]' : ''} ${className}`}
      data-testid="inkphd-mark"
      draggable="false"
    />
  );
}
